import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../../redux/actions/auth.js'

import Tab from '@material-ui/core/Tab';
import TabContext from '@material-ui/lab/TabContext';
import TabList from '@material-ui/lab/TabList';
import TabPanel from '@material-ui/lab/TabPanel';

import SupportEntries from './SupportEntries.js'
import SupportKeywords from './SupportKeywords.js'

// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

import { getAllowedRoutes } from 'utils';
import _, { get } from 'lodash'

const evt = new Event('customertable_is_dirty');

const useStyles = makeStyles((theme) => ({}))

const Support = () => {
  const auth = useSelector(state => state.auth)

  const [value, setValue] = React.useState('1');  // for tabs

  // switch tabs
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
    <TabContext value={value} style={{'marginLeft': '0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <TabList onChange={handleChange} aria-label="Subpages">
            <Tab label="Entries" value="1" />
            <Tab label="Keywords" value="2" />
          </TabList>

        <TabPanel value="1" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <SupportEntries />
        </TabPanel>

        <TabPanel value="2" style={{'marginLeft':'0', 'paddingLeft':'0', 'marginRight': '0', 'paddingRight':'0'}} >
          <SupportKeywords />
        </TabPanel>
    </TabContext>

    </>
  )
}

export default Support
